module.exports = __webpack_public_path__ + "img/icon18.787cea0b.png";